import { render, staticRenderFns } from "./DiscoverMeasuresBlock.vue?vue&type=template&id=9ff926c0&"
import script from "./DiscoverMeasuresBlock.vue?vue&type=script&lang=js&"
export * from "./DiscoverMeasuresBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports